import Translation from '../Translation/cont/Translation'

const Button = ({className, spanClassName, text, transId, onClick, hideText = true, type = "button", disabled=false, Component='button', adItemType=false}) => {
    const extraSpanClass = spanClassName ? ' ' + spanClassName : ''
    const spanClass = hideText ? "screen-reader-text" : "text" + extraSpanClass

    if(adItemType) {
        return (
            <Component type={type} className={'button ' + className} onClick={() => onClick(adItemType)} disabled={disabled}>
                <span className={spanClass}><Translation id={transId}>{text}</Translation></span>
            </Component>
        )
    } else {
        return (
            <Component type={type} className={'button ' + className} onClick={disabled ? () => {} : onClick} disabled={disabled}>
                <span className={spanClass}><Translation id={transId}>{text}</Translation></span>
            </Component>
        )
    }
}

export default Button